import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { TbPlane, TbReceipt } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../Hooks/useFetch";
import apis from "../../../../Utils/apis";

const emptyGroup = {
	approvalsToday: 0,
	totalPendingApprovals: 0,
	readyToBook: 0,
	awaitingApproval: 0,
};

function GlanceTile({ value, label, onClick, accent }) {
	const className = accent
		? "flex flex-col h-full p-4 text-left text-white bg-accent rounded-xl"
		: "flex flex-col h-full p-4 text-left border bg-whitish rounded-xl";
	const body = (
		<>
			<div className={`text-4xl font-semibold leading-none ${onClick ? "flex items-start justify-between gap-2" : ""}`}>
				{value}
				{onClick ? (
					<div className="w-8 h-8 text-lg rounded-full bg-surface flex-center shrink-0">
						<FiArrowUpRight />
					</div>
				) : null}
			</div>
			<div className={`mt-2 text-sm leading-snug ${accent ? "text-white" : "text-secondary"}`}>{label}</div>
		</>
	);

	if (!onClick) {
		return <div className={className}>{body}</div>;
	}

	return (
		<button type="button" onClick={onClick} className={`${className} cursor-pointer`}>
			{body}
		</button>
	);
}

function GlanceGroup({ icon, title, children }) {
	return (
		<div className="mt-4">
			<div className="flex items-center gap-2 text-sm font-semibold text-dark">
				{icon}
				{title}
			</div>
			<div className="grid grid-cols-1 gap-3 mt-3 sm:grid-cols-2 lg:grid-cols-4 text-dark">{children}</div>
		</div>
	);
}

function AtAGlance() {
	const navigate = useNavigate();
	const { response } = useFetch(apis.atAGlanceCount, null, {
		count: {
			flight: emptyGroup,
			expense: { approvalsToday: 0, totalPendingApprovals: 0, awaitingApproval: 0 },
		},
	});

	const flight = response.count?.flight || emptyGroup;
	const expense = response.count?.expense || emptyGroup;

	return (
		<div className="col-span-2 my-6 rounded-2xl">
			<h3 className="!text-base !font-semibold">At a Glance</h3>
			<GlanceGroup icon={<TbPlane className="text-xl" />} title="Flights">
				<GlanceTile accent value={flight.approvalsToday} label="Approvals arrived today" />
				<GlanceTile value={flight.totalPendingApprovals} label="Total pending approvals" onClick={() => navigate("/app/approvals")} />
				<GlanceTile value={flight.readyToBook} label="Approvals ready to book" onClick={() => navigate("/app/bookings?tab=ready")} />
				<GlanceTile value={flight.awaitingApproval} label="Requested approvals" onClick={() => navigate("/app/bookings?tab=requested")} />
			</GlanceGroup>
			<GlanceGroup icon={<TbReceipt className="text-xl" />} title="Expenses">
				<GlanceTile accent value={expense.approvalsToday} label="Approvals arrived today" />
				<GlanceTile value={expense.awaitingApproval} label="Requested approvals" />
			</GlanceGroup>
		</div>
	);
}

export default AtAGlance;
